import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LongtailService } from '@nx-superprep/backend/firebase';
import { CookieSettingsDialogComponent } from './cookie-settings-dialog.component'
import { BrowserStorageService } from '@nx-superprep/backend/config'

@Component({
  selector: 'pop-ui-cookie-banner',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss'
})
export class CookieBannerComponent {
  private readonly longtailService = inject(LongtailService);
  private readonly storageService = inject(BrowserStorageService);
  private readonly dialog = inject(MatDialog);

  private _showBanner = this.storageService.getItem('cookieConsent') !== 'false';
  public get showBanner() {
    return this._showBanner
  }
  public set showBanner(value) {
    this.storageService.setItem('cookieConsent', value ? 'true' : 'false');
    this._showBanner = value
  }

  // Default preferences
  preferences = {
    necessary: true,
    performance: false,
    advertising: false,
    ...JSON.parse(this.storageService.getItem('cookieConsent') || '{}')
  };

  acceptAll() {
    this.savePreferences({
      necessary: true,
      performance: true,
      advertising: true
    });
  }

  openSettings() {
    const dialogRef = this.dialog.open(CookieSettingsDialogComponent, {
      width: '90%',
      maxWidth: '600px',  // Changed from 500px to 600px
      data: { ...this.preferences },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.savePreferences(result);
      }
    });
  }

  private savePreferences(prefs: typeof this.preferences) {
    this.preferences = prefs;
    this.storageService.setItem('cookieConsent', JSON.stringify(prefs));
    this.updateTracking();
    this.showBanner = false;
  }

  private async updateTracking() {
    await this.longtailService.setAnalyticsCookie(this.preferences.performance);
    await this.longtailService.setAdvertisingCookies(this.preferences.advertising);
  }
}
